// 時間ユニット
const TU = (t) => {
	return Math.ceil(FPS * t / 60)
}

// 数字の先頭をゼロで埋める
Number.prototype.fillZero = function(n) {
	return Array((n + 1) - this.toString().split('').length).join('0') + this
}

const SCREEN_WIDTH = 640
const SCREEN_HEIGHT = 860

const MAP_TOP = 40
const MAP_LEFT = 50

const PIECE_SIZE = 120
const PARTS_SIZE = 60
const KOBITO_SIZE = 100
const LOCK_SIZE = 100
const CONFETTI_SIZE = 15

const FPS = 30
const WALK_SPEED = TU(30)
const WALK_STEP = TU(10)

// 画像を読み込む関数
const preload = (game) => {
	// マップ画像データを読み込む
	for (let i = 0; i < 16; i += 1) {
		game.preload(`images/${i}.png`)
	}

	// その他の画像・サウンドデータを読み込む
	const assets = [
		'images/top.png',
		'images/menuBg.png',
		'images/menu_lock.png',
		'images/bg.png',
		'images/parts.png',
		'images/lock.png',
		'images/kobito.png',
		'images/gameover.png',
		'images/allClBg.png',
		'images/congratulation.png',
		'images/allClGoal.png',
		'images/hand.png',
		'images/helpBg.png',
		'images/helpMsg.png',
		'images/helpOver.png',
		'images/volumeBg.png',
		'images/volumeKnob.png',
		'images/clearBg.png',
		'images/prevBtn.png',
		'images/nextBtn.png',
		'images/newBtn.png',
	]

	assets.some((asset) => {
		game.preload(asset)
	})
}

enchant()
enchant.ENV.USE_TOUCH_TO_START_SCENE = false
enchant.ENV.USE_FLASH_SOUND = false
enchant.ENV.SOUND_ENABLED_ON_MOBILE_SAFARI = false
enchant.ENV.USE_WEBAUDIO = false

const init = async () => {
	// ステージナンバー
	let stageNo = parseInt(localStorage.getItem('stageNo')) || 0

	// ゲームステージを生成する
	const game = new Game(SCREEN_WIDTH, SCREEN_HEIGHT)

	// FPSをセットする
	game.fps = FPS

	// サウンドデータを読み込む
	const sound = new SimpleAudio()
	await sound.preloads([
		'sound/button.wav',
		'sound/arrow_put.wav',
		'sound/arrow_pass.wav',
		'sound/clear.wav',
		'sound/key_get.mp3',
		'sound/lock_open.wav',
		'sound/miss.wav',
		'sound/all_clear.wav',
		'sound/clap.wav',
	])

	// 画像・サウンドデータを読み込む
	preload(game)

	game.onload = () => {

		// ========================================================
		// 各種オブジェクトの定義
		// ========================================================

		const Kobito = Class.create(Sprite, {
			initialize(loadMap, itemMap) {
				Sprite.call(this, KOBITO_SIZE, KOBITO_SIZE)
				this.image = game.assets['images/kobito.png']
				this.x = 290
				this.loadMap = loadMap
				this.itemMap = itemMap
			},
			init() {
				this.x = (SCREEN_WIDTH - KOBITO_SIZE) / 2
				this.y = MAP_TOP - PIECE_SIZE / 4 + (PIECE_SIZE - KOBITO_SIZE) / 2 - 20
				this.mx = 4
				this.my = 0
				this.direction = 3
				this.frame = 16
				this.wf = 0
			},
			walk() {
				// 行き止まりかチェック
				switch (this.direction) {
					case 1:
						this.my -= 1
						break
					case 2:
						this.mx += 1
						break
					case 3:
						this.my += 1
						break
					case 4:
						this.mx -= 1
						break
				}

				// 壁にぶつかる！
				if ((this.mx < 0) || (this.mx > 8) || (this.my < 0) || (this.my > 11) || (this.loadMap[this.my][this.mx] === 0)) {
					this.frame = 17
					this.doGameOver()
					return
				}

				let dx = 0
				let dy = 0

				switch (this.direction) {
					case 1:
						dy = - PIECE_SIZE / 2
						break
					case 2:
						dx = PIECE_SIZE / 2
						break
					case 3:
						dy = PIECE_SIZE / 2
						break
					case 4:
						dx = - PIECE_SIZE / 2
						break
				}

				this.tl
					.moveBy(dx, dy, WALK_SPEED)
					.and()
					.action({
						time: WALK_SPEED,
						onactiontick: () => {
							if (this.age % WALK_STEP === 0) {
								this.wf = (this.wf + 1) % 4
								this.frame = this.wf + this.direction * 4 - 4
							}
						}
					})
					.delay(1)
					.then(() => {
						const obj = this.itemMap[this.my][this.mx]
						switch (obj.frame) {
							// 方向転換
							case 1:
							case 2:
							case 3:
							case 4:
								sound.play('sound/arrow_pass.wav')
								this.direction = obj.frame
								obj.frame = 0
								break
							// 鍵を拾った
							case 5:
								sound.play('sound/key_get.mp3')
								obj.tl
									.moveBy(0, -90, WALK_SPEED, enchant.Easing.QUAD_EASEOUT)
									.and()
									.fadeOut(WALK_SPEED)
									.then(function() {
										obj.frame = 0
									})
								this.keyCount -= 1
								break
							// ゴール
							case 6:
								// 鍵のチェック！
								if (this.keyCount === 0) {
									this.doGoal()
									return
								}
						}

						return this.walk()
					})
			},
			banzai () {
				this.tl
					.moveBy(0, PIECE_SIZE / 2, WALK_SPEED * 2)
					.and()
					.action({
						time: WALK_SPEED * 2,
						onactiontick: () => {
							// 歩く
							if ((this.age % WALK_STEP) == 0) {
								this.wf = (this.wf + 1) % 4
								this.frame = this.wf + 8
							}
						}
					})
					.delay(1)
					.then(() => {
						sound.play('sound/clear.wav')
					})
					.action({
						time: FPS * 2,
						onactiontick: () => {
							// 万歳
							if ((this.age % (WALK_STEP * 2)) == 0) {
								this.wf = (this.wf + 1) % 2
								this.frame = this.wf + 18
							}
						}
					})
			},
			onGameOver(func) {
				this.funcOnGameOver = func
			},
			doGameOver() {
				if (typeof (this.funcOnGameOver) === 'function') {
					this.funcOnGameOver()
				}
			},
			onGoal(func) {
				this.funcOnGoal = func
			},
			doGoal() {
				if (typeof (this.funcOnGoal) === 'function') {
					this.funcOnGoal(this)
				}
			},
			allCrear() {
				this.tl
					.moveBy(0, PIECE_SIZE / 2 * 8, WALK_SPEED * 8)
					.and()
					.action({
						time: WALK_SPEED * 8,
						onactiontick: function() {
							if ((this.age % WALK_STEP) == 0) {
								this.wf = (this.wf + 1) % 4
								this.frame = this.wf + this.direction * 4 - 4
							}
						}
					})
					.action({
						time: FPS * 60 * 60,
						onactiontick: function() {
							if ((this.age % (WALK_STEP * 2)) == 0) {
								this.wf = (this.wf + 1) % 2
								this.frame = this.wf + 18
							}
						}
					})
			},
			demoWalk(dir, dist) {
				var dx = 0
				var dy = 0

				switch (dir) {
					case 1:
						dy = - PIECE_SIZE / 2
						break
					case 2:
						dx = PIECE_SIZE / 2
						break
					case 3:
						dy = PIECE_SIZE / 2
						break
					case 4:
						dx = - PIECE_SIZE / 2
						break
				}

				this.tl
					.moveBy(dx * dist, dy * dist, WALK_SPEED * dist)
					.and()
					.action({
						time: WALK_SPEED * dist,
						onactiontick: function() {
							if ((this.age % WALK_STEP) == 0) {
								this.wf = (this.wf + 1) % 4
								this.frame = this.wf + dir * 4 - 4
							}
						}
					})

				return this
			}
		});

		// 配置パーツ
		const Parts = Class.create(Sprite, {
			initialize(x, y, isKey) {
				Sprite.call(this, PARTS_SIZE, PARTS_SIZE)
				this.x = x * PIECE_SIZE / 2
				this.y = y * PIECE_SIZE / 2
				this.sx = this.x
				this.sy = this.y
				this.image = game.assets['images/parts.png']
				this.lastTouchTime = 0

				if (isKey) {
					this.frame = 5
				}

				this.on('touchstart', function(e) {
					if (this.frame < 5) {
						this.saveX = e.x - this.x
						this.saveY = e.y - this.y
						this.opacity = 0.5
						this.clickTime = +new Date()
					}
				});

				this.on('touchmove', function (e) {
					if (this.frame < 5) {
						this.x = e.x - this.saveX
						this.y = e.y - this.saveY
					}
				});

				this.on('touchend', function (e) {
					if (this.frame < 5) {
						// 長押しでなければ、回転する
						if ((+new Date() - this.clickTime) < 300) {
							this.frame = (this.frame % 4) + 1
						}

						// 移動距離が多ければ、消去する
						if ((Math.pow(this.sx - this.x, 2) + Math.pow(this.sy - this.y, 2)) > PARTS_SIZE * PARTS_SIZE * 0.7) {
							this.frame = 0
						}

						// 位置を元に戻す
						this.x = this.sx
						this.y = this.sy
						this.opacity = 1

						sound.play('sound/arrow_put.wav')
					}

				})
			}
		})

		// 錠
		const Lock = Class.create(Sprite, {
			initialize() {
				Sprite.call(this, LOCK_SIZE, LOCK_SIZE)
				this.image = game.assets['images/lock.png']
				this.x = (SCREEN_WIDTH - LOCK_SIZE) / 2
				this.y = MAP_TOP + PIECE_SIZE * 6 - 20
			},
			init() {
				this.frame = 0
				this.tl.fadeIn(1)
			},
			open() {
				sound.play('sound/lock_open.wav')
				this.frame = 1
				this.tl
					.delay(TU(10))
					.then(function() {
						this.frame = 2
					})
					.delay(TU(10))
					.fadeOut(TU(10))
			}
		})

		// 紙吹雪
		const Confetti = Class.create(Sprite, {
			initialize() {
				const size = (Math.random() * 0.2 + 0.8) * CONFETTI_SIZE
				Sprite.call(this, size, size)
				this.backgroundColor = Math.random() > 0.5 ? '#ed1a3d' : '#fff'
				this.x = SCREEN_WIDTH * Math.random()
				this.y = - SCREEN_HEIGHT * Math.random() / 2
				this.vx = Math.random() * 4 - 2
				this.vy = Math.random() * 4 + 4
				this.degree = Math.random() * 360
			},
			onenterframe() {
				this.degree += 1
				this.y += this.vy
				// 画面から出たか判定する
				if (SCREEN_HEIGHT < this.y) {
					this.delete()
					return
				}
				this.x += this.vx + Math.cos(this.degree * Math.PI / 180) * 3
				this.scaleY = Math.cos(this.degree * Math.PI / 45)
				this.rotation = this.degree
			}
		})


		// ゲームオーバー
		const GameOverDlg = Class.create(Group, {
			initialize() {
				Group.call(this)

				this.x = (SCREEN_WIDTH - 390) / 2
				this.y = SCREEN_HEIGHT

				const bg = new Sprite(390, 430)
				bg.image = game.assets['images/gameover.png']
				this.addChild(bg)

				const replay = new Sprite(210, 60)
				replay.x = 90
				replay.y = 206
				replay.on('touchstart', () => {
					sound.play('sound/button.wav')

					this.tl.cue({
						[TU(20)]: () => { this.scene.cover.tl.fadeIn(TU(20)) },
						[TU(40)]: () => { this.scene.init() },
					})
				})

				this.addChild(replay);

				const menu = new Sprite(210, 60)
				menu.x = 90
				menu.y = 310
				menu.on('touchstart', () => {
					sound.play('sound/button.wav')
					this.tl.cue({
						[TU(20)]: () => { this.scene.cover.tl.fadeIn(TU(20)) },
						[TU(40)]: () => { menuScene.showScene() },
					})
				})

				this.addChild(menu)
			},
			init() {
				this.y = SCREEN_HEIGHT
			},
			popup() {
				this.tl
					.tween({
						y: (SCREEN_HEIGHT - 430) / 2,
						time: TU(20),
					})
			}
		})


		// ========================================================
		// ゲームクリアシーンの定義
		// ========================================================

		// ゲームクリア
		const GameClearDlg = Class.create(Group, {
			initialize() {
				Group.call(this)

				this.bg = new Sprite(600, 800)
				this.bg.image = game.assets['images/clearBg.png']
				this.addChild(this.bg)

				this.x = (SCREEN_WIDTH - this.bg.width) / 2

				const goMenu = new Sprite(300, 150)
				goMenu.x = 0
				goMenu.y = 0
				goMenu.on('touchstart', () => {
					sound.play('sound/button.wav')
					this.init()
					this.scene.cover.tl
						.fadeIn(TU(20))
						.then(() => {
							menuScene.showScene()
						})
				})

				this.addChild(goMenu)

				var nextStage = new Sprite(300, 150)
				nextStage.x = 300
				nextStage.y = 0
				nextStage.on('touchstart', () => {
					sound.play('sound/button.wav')
					this.init()
					this.scene.cover.tl
						.fadeIn(TU(20))
						.then(() => {
							gameScene.showScene(this.scene.stageNo + 1)
						})
				})

				this.addChild(nextStage)
			},
			init() {
				this.y = SCREEN_HEIGHT
				this.bg.opacity = 0
			},
			popup () {
				this.y = (SCREEN_HEIGHT - this.bg.height) / 2
				this.bg.tl
					.fadeIn(TU(20))
			}
		})


		// ========================================================
		// ヘルプシーンの定義
		// ========================================================

		const HelpScene = Class.create(Group, {
			initialize() {
				Group.call(this)

				this.x = -SCREEN_WIDTH

				const bg = new Sprite(SCREEN_WIDTH, SCREEN_HEIGHT)
				bg.image = game.assets['images/helpBg.png']
				this.addChild(bg)

				const itemGroup = new Group()
				itemGroup.x = MAP_LEFT
				itemGroup.y = MAP_TOP
				this.addChild(itemGroup)

				this.arrows = [
					[4, 2, 2],
					[8, 2, 3],
					[8, 6, 4],
					[0, 6, 3],
					[0, 10, 2],
					[4, 10, 3],
					[5, 6, 1]
				].map((param) => {
					const arrow = new Parts(param[0], param[1], false)
					arrow.frame = param[2]
					arrow.visible = false
					arrow.touchEnabled = false
					itemGroup.addChild(arrow)
					return arrow
				})

				this.keys = [
					[8, 4],
					[0, 8]
				].map((param) => {
					const key = new Parts(param[0], param[1], true)
					key.get = function() {
						sound.play('sound/key_get.mp3')
						this.tl
							.moveBy(0, -90, TU(20), enchant.Easing.QUAD_EASEOUT)
							.and()
							.fadeOut(TU(20))
					}
					itemGroup.addChild(key)
					return key
				})

				this.kobito = new Kobito()
				this.addChild(this.kobito)

				const hand = new Sprite(150, 150)
				hand.image = game.assets['images/hand.png']
				hand.tap = function() {
					this.tl
						.then(function() {
							this.frame = 1
						})
						.delay(TU(20))
						.then(function() {
							this.frame = 0
							sound.play('sound/arrow_put.wav')
						})
				}
				hand.pos = function(x, y) {
					this.x = x
					this.y = y
				}
				hand.fadeIn = function() {
					this.tl.fadeIn(TU(30))
				}
				hand.fadeOut = function () {
					this.tl.fadeOut(TU(30))
				}
				this.hand = hand
				this.addChild(hand)

				const over = new Sprite(1280, 1720)
				over.image = game.assets['images/helpOver.png']
				over.pos = function (x, y) {
					this.x = x
					this.y = y
				}
				over.fadeIn = function () {
					this.tl.fadeIn(TU(30))
				}
				over.fadeOut = function () {
					this.tl.fadeOut(TU(30))
				}
				over.visible = false
				this.over = over
				this.addChild(over)

				const msg = new Sprite(476, 130)
				msg.image = game.assets['images/helpMsg.png']
				msg.y = 240
				msg.in = function () {
					this.tl.moveX(30, TU(40),
					enchant.Easing.EXPO_EASEOUT)
				}
				msg.out = function () {
					this.tl.moveX(-500, TU(20))
					this.frame += 1
				}
				this.msg = msg
				this.addChild(msg)

				const close = new Sprite(88, 88)
				close.x = 542
				close.y = 12
				close.on('touchstart', () => {
					this.tl
						.clear()
						.moveX(-SCREEN_WIDTH, TU(20))
						.then(() => {
							this.over.visible = false
						})
				})
				this.addChild(close)
			},
			open() {
				sound.play('sound/button.wav')

				const kobito = this.kobito
				const msg = this.msg
				const hand = this.hand
				const over = this.over
				const arrows = this.arrows
				const keys = this.keys

				const arrow = this.arrows[6]

				arrow.frame = 1
				arrow.x = arrow.sx
				arrow.y = arrow.sy

				msg.x = -500
				msg.frame = 0

				hand.x = 80
				hand.y = SCREEN_HEIGHT
				hand.opacity = 0

				over.opacity = 0
				over.visible = true

				kobito.init()

				arrows.forEach((arrow) => {
					arrow.visible = false
					arrow.opacity = 1
				})

				keys.forEach((key) => {
					key.x = key.sx
					key.y = key.sy
					key.opacity = 1
				})

				this.tl
					.moveX(0, TU(20))
					.delay(TU(20)).then(() => {
						msg.in()
					})
					.delay(TU(100)).then(() => {
						over.pos(-320, -410)
						over.fadeIn()
					})
					.delay(TU(30)).then(() => {
						hand.pos(240, 380)
						hand.fadeIn()
					})
					.delay(TU(30)).then(() => {
						hand.tap()
					})
					.delay(TU(20)).then(() => {
						arrow.visible = true
					})
					.delay(TU(30)).then(() => {
						msg.out()
						over.fadeOut()
						hand.fadeOut()
					})
					.delay(TU(40)).then(() => {
						msg.in()
					})
					.delay(TU(100)).then(() => {
						hand.fadeIn()
						over.fadeIn()
					})
					.delay(TU(30)).then(() => {
						hand.tap()
					})
					.delay(TU(20)).then(() => {
						arrow.frame += 1
					})
					.delay(TU(20)).then(() => {
						hand.tap()
					})
					.delay(TU(20)).then(() => {
						arrow.frame += 1
					})
					.delay(TU(20)).then(() => {
						hand.tap()
					})
					.delay(TU(20)).then(() => {
						arrow.frame += 1
					})
					.delay(TU(30)).then(() => {
						msg.out()
						over.fadeOut()
						hand.fadeOut()
					})
					.delay(TU(40)).then(() => {
						msg.in()
					})
					.delay(TU(100)).then(() => {
						hand.fadeIn()
						over.fadeIn()
					})
					.delay(TU(30)).then(() => {
						hand.frame = 1
					})
					.delay(TU(20)).then(() => {
						hand.tl.moveBy(PARTS_SIZE, PARTS_SIZE, TU(20))
						arrow.tl.moveBy(PARTS_SIZE, PARTS_SIZE, TU(20))
					})
					.delay(TU(50)).then(() => {
						hand.frame = 0
						arrow.tl.fadeOut(TU(20))
					})
					.delay(TU(30)).then(() => {
						msg.out()
						over.fadeOut()
						hand.fadeOut()
					})
					.delay(TU(40)).then(() => {
						msg.in()
					})
					.delay(TU(100)).then(() => {
						arrows[0].visible = true
						hand.pos(350, 730)
						hand.fadeIn()
						over.pos(-160, -70)
						over.fadeIn()
					})
					.delay(TU(30)).then(() => {
						hand.tap()
					})
					.delay(TU(20)).then(() => {
						hand.fadeOut()
						over.fadeOut()
						kobito.demoWalk(3, 2)
						msg.out()
					})
					.delay(WALK_SPEED * 2).then(() => {
						sound.play('sound/arrow_pass.wav')
						arrows[0].visible = false
						kobito.demoWalk(2, 4)
					})
					.delay(WALK_SPEED * 4 + TU(10)).then(() => {
						sound.play('sound/miss.wav')
						kobito.frame = 17
						msg.in()
					})
					.delay(TU(100)).then(() => {
						msg.out()
						kobito.tl.fadeOut(TU(20))
					})
					.delay(TU(40)).then(() => {
						kobito.init()
						kobito.tl.fadeIn(TU(20))
					})
					.delay(TU(20)).then(() => {
						hand.pos(180, 140)
						hand.fadeIn()
						hand.tap()
					})
					.delay(TU(40)).then(() => {
						arrows[0].visible = true
						hand.tl.moveTo(420, 140, TU(20))
						hand.tap()
					})
					.delay(TU(40)).then(() => {
						arrows[1].visible = true
						hand.tl.moveTo(420, 380, TU(20))
						hand.tap()
					})
					.delay(TU(40)).then(() => {
						arrows[2].visible = true
						hand.tl.moveTo(-60, 380, TU(20))
						hand.tap()
					})
					.delay(TU(40)).then(() => {
						arrows[3].visible = true
						hand.tl.moveTo(-60, 620, TU(20))
						hand.tap()
					})
					.delay(TU(40)).then(() => {
						arrows[4].visible = true
						hand.tl.moveTo(180, 620, TU(20))
						hand.tap()
					})
					.delay(TU(40)).then(() => {
						arrows[5].visible = true
						hand.tl.moveTo(350, 740, TU(20))
						hand.tap()
					})
					.delay(TU(40)).then(() => {
						hand.fadeOut()
						kobito
							.demoWalk(3, 2)
							.demoWalk(2, 4)
							.demoWalk(3, 4)
							.demoWalk(4, 8)
							.demoWalk(3, 4)
							.demoWalk(2, 4)
							.demoWalk(3, 1)
							.banzai()
					})
					.delay(WALK_SPEED * 2).then(() => {
						arrows[0].visible = false
						sound.play('sound/arrow_pass.wav')
					})
					.delay(WALK_SPEED * 4).then(() => {
						arrows[1].visible = false
						sound.play('sound/arrow_pass.wav')
					})
					.delay(WALK_SPEED * 2).then(() => {
						keys[0].get()
						msg.in()
					})
					.delay(WALK_SPEED * 2).then(() => {
						arrows[2].visible = false
						sound.play('sound/arrow_pass.wav')
					})
					.delay(WALK_SPEED * 8).then(() => {
						arrows[3].visible = false
						sound.play('sound/arrow_pass.wav')
					})
					.delay(WALK_SPEED * 2).then(() => {
						keys[1].get()
					})
					.delay(WALK_SPEED * 2).then(() => {
						arrows[4].visible = false
						sound.play('sound/arrow_pass.wav')
					})
					.delay(WALK_SPEED * 4).then(() => {
						arrows[5].visible = false
						sound.play('sound/arrow_pass.wav')
					})
					.delay(WALK_SPEED * 3 + TU(110)).then(() => {
						this.tl.moveX(-SCREEN_WIDTH, TU(40))
						over.visible = false
					})
			}
		})


		// ========================================================
		// ゲームシーンの定義
		// ========================================================

		const GameScene = Class.create(Scene, {
			initialize() {
				Scene.call(this)

				this.stageNo = 0

				// 通路マップ配列
				this.loadMap = []

				// アイテムオブジェクト保持配列
				this.itemMap = []

				// 背景スプライト
				this.bgSprite = new Sprite(SCREEN_WIDTH, SCREEN_HEIGHT)
				this.addChild(this.bgSprite)

				this.itemGroup = new Group()
				this.itemGroup.x = MAP_LEFT
				this.itemGroup.y = MAP_TOP
				this.addChild(this.itemGroup)

				// ステージ番号
				this.stageLabel = new Label()
				this.stageLabel.font = '47px Roboto'
				this.stageLabel.color = '#FFF'
				this.stageLabel.x = 514
				this.stageLabel.y = 40
				this.addChild(this.stageLabel)

				// メニューボタン
				const goMenu = new Sprite(60, 60)
				goMenu.x = 30
				goMenu.y = 38
				goMenu.on('touchstart', () => {
					this.goMenu()
				})
				this.addChild(goMenu)

				// ヘルプボタン
				const showHelp = new Sprite(60, 60)
				showHelp.x = 107
				showHelp.y = 38
				showHelp.on('touchstart', () => {
					helpScene.open()
				})
				this.addChild(showHelp)

				// ゴーボタン
				const gobtn = new Sprite(150, 60)
				gobtn.x = 440
				gobtn.y = 760
				gobtn.on('touchstart', () => {
					this.kobitoStart()
				})
				this.addChild(gobtn)

				// リスタートボタン
				const replay = new Sprite(150, 60)
				replay.x = 48
				replay.y = 760
				replay.on('touchstart', () => {
					this.replay()
				});
				this.addChild(replay)

				// 錠を配置
				this.lock = new Lock()
				this.addChild(this.lock)

				// 小人を配置する
				const kobito = new Kobito(this.loadMap, this.itemMap)
				kobito.onGoal(() => {
					this.goal()
				})
				kobito.onGameOver(() => {
					this.gameOver()
				})
				this.kobito = kobito
				this.addChild(kobito)

				// カバー
				this.cover = new Sprite(SCREEN_WIDTH, SCREEN_HEIGHT)
				this.cover.backgroundColor = "#000"
				this.addChild(this.cover)

				// ゲームオーバーダイヤログ
				this.gameOverDlg = new GameOverDlg()
				this.addChild(this.gameOverDlg)

				// ゲームクリアダイヤログ
				this.gameClearDlg = new GameClearDlg()
				this.addChild(this.gameClearDlg)

			},
			showScene(stageNo) {
				if (stageNo < stageData.length) {
					this.cover.opacity = 1
					this.stageNo = stageNo
					game.replaceScene(this)
					this.addChild(helpScene)
					this.init()
				} else {
					// ステージが無い場合は、メニューを表示する
					menuScene.showScene()
				}
			},
			init() {
				// オブジェクトの初期化
				this.kobito.init()
				this.lock.init()
				this.gameOverDlg.init()
				this.gameClearDlg.init()

				const data = stageData[this.stageNo]

				this.stageLabel.text = (this.stageNo + 1).fillZero(3)

				const mapData = JSON.parse(JSON.stringify(data.map))
				const keyData = data.key

				mapData.unshift([0, 0, 4, 0, 0])
				mapData.push([0, 0, 1, 0, 0])

				// 背景画像を描画する
				const bgSurface = new Surface(game.width, game.height)
				bgSurface.draw(game.assets['images/bg.png'])

				// マップ画像を描画する
				const offX = MAP_LEFT - (PIECE_SIZE - PARTS_SIZE) / 2
				const offY = MAP_TOP - (PIECE_SIZE - PARTS_SIZE) / 2
				mapData.forEach((line, y) => {
					line.forEach((p, x) => {
						bgSurface.draw(game.assets[`images/${p}.png`], x * PIECE_SIZE + offX, y * PIECE_SIZE + offY)
					})
				})
				this.bgSprite.image = bgSurface

				// マップ上のオブジェクトを消去する
				while (this.itemGroup.childNodes.length > 0) {
					this.itemGroup.removeChild(this.itemGroup.lastChild)
				}

				// 判定用マップを初期化する
				for (let y = 0; y < 13; y += 1) {
					this.loadMap[y] = [0, 0, 0, 0, 0, 0, 0, 0, 0]
					this.itemMap[y] = []
				}

				// マップデータを書き込む
				for (let y = 0; y < 7; y += 1) {
					for (let x = 0; x < 5; x += 1) {
						this.loadMap[y * 2][x * 2] = mapData[y][x]
					}
				}

				// マップ間を補完する
				for (let y = 0; y < 13; y += 1) {
					for (let x = 0; x < 9; x += 1) {
						if ((x & 1) || (y & 1)) {
							this.loadMap[y][x] =
								((y > 0) ? ((this.loadMap[y - 1][x] & 4) ? 1 : 0) : 0)
								+ ((x < 8) ? ((this.loadMap[y][x + 1] & 8) ? 2 : 0) : 0)
								+ ((y < 12) ? ((this.loadMap[y + 1][x] & 1) ? 4 : 0) : 0)
								+ ((x > 0) ? ((this.loadMap[y][x - 1] & 2) ? 8 : 0) : 0)
						}
					}
				}

				// アイテムオブジェクトを配置する
				for (let y = 0; y < 13; y += 1) {
					for (let x = 0; x < 9; x += 1) {
						if (this.loadMap[y][x]) {
							const obj = new Parts(x, y, false)
							this.itemMap[y][x] = obj
							this.itemGroup.addChild(obj)
						}
					}
				}

				// キーを設定する
				keyData.forEach((key) => {
					const obj = this.itemMap[key[1]][key[0]]
					if (obj) {
						obj.frame = 5
					} else {
						console.log(`鍵配置エラー(${key[0]}, ${key[1]})`)
					}
				})

				this.kobito.keyCount = keyData.length

				// ゴールを設定する
				this.itemMap[11][4].frame = 6

				this.cover.tl
					.fadeOut(WALK_SPEED)
					.moveTo(SCREEN_WIDTH, 0, 1)

			},
			kobitoStart() {
				sound.play('sound/button.wav')
				this.cover.x = 0
				this.kobito.walk()
			},
			gameOver() {
				sound.play('sound/miss.wav')
				this.gameOverDlg.popup()
				this.cover.tl.tween({
					opacity: 0.5,
					time: TU(20)
				})
			},
			goal() {
				// ステージを更新する
				let allClearFlag = false
				if (this.stageNo === stageNo) {
					stageNo += 1
					localStorage.setItem('stageNo', stageNo)

					if (stageNo === stageData.length) {
						// 全クリア
						allClearFlag = true
					}
				}

				// アニメーションを再生する
				this.tl.cue({
					0: () => { this.lock.open() },
					[TU(30)]: () => { this.kobito.banzai() },
					[TU(180)]: () => { this.cover.tl.fadeTo(0.2, TU(30)) },
					[TU(210)]: () => {
						if (allClearFlag) {
							showAllClearScene()
						} else {
							this.gameClearDlg.popup()
						}
					},
				})
			},
			goMenu() {
				sound.play('sound/button.wav')
				menuScene.showScene()
			},
			replay() {
				sound.play('sound/button.wav')
				this.init()
			}
		})


		// ========================================================
		// スタートシーンの定義
		// ========================================================

		let isInitializedWebAudio = false

		const TopScene = Class.create(Scene, {
			initialize() {
				Scene.call(this)

				const bg = new Sprite(SCREEN_WIDTH, SCREEN_HEIGHT)
				bg.image = game.assets['images/top.png']
				this.addChild(bg)

				const goMenu = new Sprite(SCREEN_WIDTH, 80)
				goMenu.y = 590
				goMenu.on('touchstart', () => {
					this.initSound()
					sound.play('sound/button.wav')
					this.cover.tl
						.moveX(0, 1)
						.fadeIn(TU(20))
						.then(() => {
							menuScene.showScene()
						})
				});
				this.addChild(goMenu)

				const showHelp = new Sprite(SCREEN_WIDTH, 80)
				showHelp.y = 690
				showHelp.on('touchstart', () => {
					this.initSound()
					helpScene.open()
				})
				this.addChild(showHelp)

				this.cover = new Sprite(SCREEN_WIDTH, SCREEN_HEIGHT)
				this.cover.backgroundColor = '#000'
				this.addChild(this.cover);
			},
			showScene() {
				game.replaceScene(this)
				this.addChild(helpScene)
				this.cover.tl.fadeOut(TU(20)).moveX(SCREEN_WIDTH, 1)
			},
			initSound() {
				if (!isInitializedWebAudio && enchant.ENV.USE_WEBAUDIO && enchant.ENV.USE_TOUCH_TO_START_SCENE) {
					const a = new enchant.WebAudioSound()
					a.buffer = enchant.WebAudioSound.audioContext.createBuffer(1, 1, 48000)
					a.play()
					isInitializedWebAudio = true
				}
			},
		})


		// ========================================================
		// メニューシーンの定義
		// ========================================================

		const MenuScene = Class.create(Scene, {
			initialize() {
				Scene.call(this)

				this.page = Math.floor(stageNo / 25) - ((stageData.length === stageNo) ? 1 : 0)

				const bg = new Sprite(SCREEN_WIDTH, SCREEN_HEIGHT)
				bg.image = game.assets['images/menuBg.png']
				this.addChild(bg)

				const goHome = new Sprite(60, 60)
				goHome.x = 30
				goHome.y = 38
				goHome.on('touchstart', () => {
					this.goHome()
				});
				this.addChild(goHome)

				this.labels = []
				for (let y = 0; y < 5; y += 1) {
					for (let x = 0; x < 5; x += 1) {
						const label = new Label()
						label.font = '56px Roboto'
						label.color = '#FFF'
						label.textAlign = 'center'
						label.x = x * 120 + 30
						label.y = y * 120 + 167
						label.width = 100
						this.addChild(label)
						this.labels.push(label)
					}
				}

				this.buttons = []
				for (let y = 0; y < 5; y += 1) {
					for (let x = 0; x < 5; x += 1) {
						const btn = new Sprite(100, 100)
						btn.image = game.assets['images/menu_lock.png']
						btn.x = x * 120 + 30
						btn.y = y * 120 + 140
						btn.stageNo = y * 5 + x
						btn.on('touchstart', ({ target }) => {
							if (target.frame == 1) {
								sound.play('sound/button.wav')
								const stageNo = target.stageNo + this.page * 25
								this.cover.tl
									.moveX(0, 1)
									.fadeIn(TU(20))
									.then(() => {
										gameScene.showScene(stageNo)
									})
							}
						})
						this.addChild(btn)
						this.buttons[btn.stageNo] = btn
					}
				}

				const pagePrvBtn = new Sprite(160, 68)
				pagePrvBtn.image = game.assets['images/prevBtn.png']
				pagePrvBtn.x = 20
				pagePrvBtn.y = 760
				pagePrvBtn.on('touchstart', () => {
					if (this.page !== 0) {
						sound.play('sound/button.wav')
						this.page -= 1
						this.init()
					}
				})
				this.pagePrvBtn = pagePrvBtn
				this.addChild(pagePrvBtn)

				const pageNxtBtn = new Sprite(160, 68)
				pageNxtBtn.image = game.assets['images/nextBtn.png']
				pageNxtBtn.x = 460
				pageNxtBtn.y = 760
				pageNxtBtn.on('touchstart', () => {
					if (this.page < (stageData.length / 25 - 1)) {
						sound.play('sound/button.wav')
						this.page += 1
						this.init()
					}
				})
				this.pageNxtBtn = pageNxtBtn
				this.addChild(pageNxtBtn)

				this.cover = new Sprite(SCREEN_WIDTH, SCREEN_HEIGHT)
				this.cover.backgroundColor = "#000"
				this.addChild(this.cover);
			},
			goHome() {
				sound.play('sound/button.wav')
				topScene.showScene()
			},
			showScene() {
				this.init()
				game.replaceScene(this)
				this.cover.tl
					.fadeOut(TU(20))
					.moveX(SCREEN_WIDTH, 1)
			},
			init() {
				this.buttons.forEach((button, i) => {
					const idx = i + this.page * 25
					button.frame = (stageNo < idx) ? 0 : 1
					this.labels[i].text = idx + 1
				})

				this.pagePrvBtn.visible = this.page !== 0
				this.pageNxtBtn.visible = (this.page < Math.floor(stageNo / 25))
					&& (this.page < (Math.floor(stageData.length / 25) - 1))
			},
		})


		// ========================================================
		// 全クリアシーンの定義
		// ========================================================

		const AllClearScene = Class.create(Scene, {
			initialize() {
				Scene.call(this);

				const bg = new Sprite(SCREEN_WIDTH, SCREEN_HEIGHT)
				bg.image = game.assets['images/allClBg.png']
				this.addChild(bg)

				const kobito = new Kobito()
				kobito.init()
				this.addChild(kobito)

				const flag = new Sprite(128, 60)
				flag.image = game.assets['images/allClGoal.png']
				flag.x = (SCREEN_WIDTH - flag.width) / 2
				flag.y = 386
				this.addChild(flag)

				const cong = new Sprite(422, 105)
				cong.image = game.assets['images/congratulation.png']
				cong.x = (SCREEN_WIDTH - cong.width) / 2
				cong.y = SCREEN_HEIGHT
				this.addChild(cong)

				// ステージ番号
				const stageLabel = new Label(stageNo)
				stageLabel.font = '120px Roboto'
				stageLabel.color = '#FFF'
				stageLabel.textAlign = 'right'
				stageLabel.x = 406
				stageLabel.y = 30
				stageLabel.width = 200
				this.addChild(stageLabel)

				// ホームボタン
				const goMenu = new Sprite(60, 60)
				goMenu.x = 26
				goMenu.y = 36
				goMenu.on('touchstart', () => {
					kobito.tl.clear()
					menuScene.showScene()
				})
				this.addChild(goMenu)

				const cover = new Sprite(SCREEN_WIDTH, SCREEN_HEIGHT)
				cover.backgroundColor = '#000'
				this.addChild(cover)

				game.replaceScene(this)

				this.tl.cue({
					[TU(30)]: () => {
						cover.tl
							.fadeOut(TU(30))
							.moveX(SCREEN_WIDTH, 1)
					},
					[TU(40)]: () => {
						kobito.allCrear()
						sound.play('sound/clap.wav')
					},
					[TU(40) + WALK_SPEED * 8]: () => {
						sound.play('sound/all_clear.wav')
						cong.tl.moveY(633, FPS, enchant.Easing.ELASTIC_EASEOUT)

						// 紙吹雪
						this.onenterframe = () => {
							const confetti = new Confetti()
							confetti.delete = () => {
								this.removeChild(confetti)
								confetti.disableCollection()
							}
							this.addChild(confetti)
						}
					},
				})
			}
		})

		const showAllClearScene = () => {
			new AllClearScene()
		}

		const topScene = new TopScene()

		const menuScene = new MenuScene()

		const gameScene = new GameScene()

		const helpScene = new HelpScene()

		// メインシーンをセットする
		topScene.showScene()
	}

	// ゲームスタート
	game.start()

}
